<template>
  <div class="app-container container-fluid">
    <div class="row">
      <h5 class="col-1">
        {{ $t('action.filter') }}
      </h5>
      <div class="col-3">
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text"> Por Tipo </span>
          </div>
          <select v-model="filter.type" class="custom-select" @change="onChange">
            <option value="ALL">
              Todos
            </option>
            <option value="Smartdrone">
              Smartdrone
            </option>
            <option value="Presupuesto">
              Presupuestos
            </option>
            <option value="Sancor">
              Sancor Seguros
            </option>
            <option value="Daferol">
              Daferol
            </option>
            <option value="Termalesuy">
              Termalesuy
            </option>
            <option value="AMV">
              AMV
            </option>
            <option value="Zerisur">
              Zerisur
            </option>
            <option value="PcService">
              PcService
            </option>
          </select>
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text"> Estado </span>
          </div>
          <select v-model="filter.state" class="custom-select" @change="onChange">
            <option value="ALL">
              Todos
            </option>
            <option value="open">
              Todos los Abiertos
            </option>
            <option value="repaired">
              Los Reparados
            </option>
            <option value="ended">
              Todos en Finalizado
            </option>
            <option value="closed">
              Cerrados
            </option>
          </select>
        </div>
        <div class="input-group mb-1">
          <div class="input-group-prepend">
            <span class="input-group-text"> {{ $t('sidebar.employees') }} </span>
          </div>
          <select v-model="filter.technician" class="custom-select" @change="onChange">
            <option value="ALL">
              {{ $t('common.all') }}
            </option>
            <option v-for="(tech, name) in technicians" :key="name" :value="tech.username">
              {{ tech.username | capitalize }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-1 date-filter-title">
        <b>Filtrado por Fechas:</b>
      </div>
      <div class="col-2">
        <div class="filter-date-type">
          <label style="width:100%" class="mb-1">
            <input v-model="selectedDate.type" type="radio" value="creation"> Creación
          </label>
          <label style="width:100%" class="mb-1">
            <input v-model="selectedDate.type" type="radio" value="updated"> Modificado
          </label>
          <label style="width:100%" class="mb-1">
            <input v-model="selectedDate.type" type="radio" value="closed"> Cerrado
          </label>
        </div>
      </div>
      <div class="col-3">
        <div class="filter-date-between">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Desde </span>
            </div>
            <input v-model="selectedDate.from" type="date" class="form-control" placeholder="desde">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Hasta </span>
            </div>
            <input v-model="selectedDate.to" type="date" class="form-control" placeholder="hasta">
          </div>
        </div>
      </div>
      <div class="col-2 filter-actions">
        <button class="btn btn-primary" @click="doFilter">
          {{ $t('action.filter') }}
        </button>
        <br>
        <button class="btn btn-danger" @click="removeFilter">
          {{ $t('action.remove_filter') }}
        </button>
      </div>
    </div>
    <div class="row">
      <FilenameOption v-model="filename" style="padding-right:0;" class="col-4" />
      <AutoWidthOption v-model="autoWidth" style="padding:0;" class="col-4" />
      <BookTypeOption v-model="bookType" style="padding:0;text-align:center;" class="col-2" />
      <div class="col-2">
        <el-button :loading="downloadLoading" type="primary" icon="el-icon-document" @click="handleDownload">
          {{ $t('excel.export') }}
        </el-button>
      </div>
    </div>
    <hr>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Cargando..." border fit highlight-current-row @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center" />
      <el-table-column align="center" label="Id" width="75">
        <template slot-scope="scope">
          {{ getTicketId(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="Fecha" width="95">
        <template slot-scope="scope">
          {{ formatDate(scope.row.dateCreated) }}
        </template>
      </el-table-column>
      <el-table-column label="Cliente">
        <template slot-scope="scope">
          {{ scope.row.customer.firstName }} ({{ scope.row.customer.phone }})
        </template>
      </el-table-column>
      <el-table-column label="Técnico" width="105">
        <template slot-scope="scope">
          {{ scope.row.assignedTo && scope.row.assignedTo.username }}
        </template>
      </el-table-column>
      <el-table-column label="Problema">
        <template slot-scope="scope">
          {{ scope.row.issueDescription }}
        </template>
      </el-table-column>
      <el-table-column label="Diagnóstico">
        <template slot-scope="scope">
          {{ scope.row.issueDiagnostic }}
        </template>
      </el-table-column>
      <el-table-column label="Estado" width="150">
        <template slot-scope="scope">
          <!-- {{ translateStatus(scope.row.status) }} -->
          <span v-if="scope.row.status2">{{scope.row.status2.name}}</span>
          <span v-else>Nuevo</span>
        </template>
      </el-table-column>
      <el-table-column label="Activo" width="64">
        <template slot-scope="scope">
          {{ getActive(scope.row.active) }}
        </template>
      </el-table-column>
      <!-- <el-table-column label="Author" width="110" align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.author }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Readings" width="115" align="center">
        <template slot-scope="scope">
          {{ scope.row.pageviews }}
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import IssueService from '@/services/issue.service';
import UserService from '@/services/user.service';
import ExtraFieldService from '@/services/extrafield.service';
import ProductService from '@/services/product.service';
import { getTicketId, formatDate } from '@/utils/page-utils';
// options components
import FilenameOption from './components/FilenameOption';
import AutoWidthOption from './components/AutoWidthOption';
import BookTypeOption from './components/BookTypeOption';

export default {
    name: 'ExportExcel',
    components: { FilenameOption, AutoWidthOption, BookTypeOption },
    filters: {
        capitalize: function capitalize(value) {
            return !value ? '' : value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
        }
    },
    data() {
        return {
            rawList: [],
            list: null,
            listLoading: true,
            multipleSelection: [],
            downloadLoading: false,
            technicians: [],
            filter: {
                type: 'ALL',
                state: 'ALL',
                technician: 'ALL',
                customer: 'ALL'
            },
            selectedDate: {
                type: 'creation',
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10)
            },
            addtHeader: [],
            addfilterVal: [],
            filename: '',
            autoWidth: true,
            bookType: 'xlsx'
        };
    },
    created() {
        this.fetchData();
        this.getTechnicians();
    },
    methods: {

        getTicketId,
        formatDate,
        getActive(active) {
            return active ? '✓' : '✗';
        },
        getTechnicians() {
            UserService.getTechnicians().then(
                response => {
                    this.technicians = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        fetchData(filteredBy, filterDate) {
            const self = this;
            let fromDate, toDate;
            let tempDate;

            if (filterDate || !this.rawList.length) {
                this.listLoading = true;

                // sanity check duplicates
                fromDate = new Date(this.selectedDate.from).getTime();
                toDate = new Date(this.selectedDate.to).getTime();

                if (fromDate > toDate) {
                    tempDate = this.selectedDate.to;
                    this.selectedDate.to = this.selectedDate.from;
                    this.selectedDate.from = tempDate;
                }

                IssueService.getIssuesByDate(this.selectedDate.type, this.selectedDate.from, this.selectedDate.to).then(
                    response => {
                        self.rawList = response.data;
                        self.doFiltering(self.rawList, filteredBy);

                        self.rawList.forEach(ticket => {
                            ticket['Precio'] = 0;
                            ticket['Costo'] = 0;

                            ProductService.getProductList(ticket.id).then(
                                responsePL => {
                                    if (responsePL.data.productLines && responsePL.data.productLines.length) {
                                        responsePL.data.productLines.forEach(product => {
                                            ticket['Precio'] += product.price * product.quantity;
                                            ticket['Costo'] += product.cost * product.quantity;
                                        });
                                    }
                                },
                                error => {
                                    console.log(error.response && error.response.data ||
                          error.message || error.toString());
                                });
                        });

                        ExtraFieldService.existReportable().then(
                            responsex => {
                                // Save me this query if no reportable exists
                                if (responsex.data) {
                                    self.list.forEach((ticket, index) => {
                                        ExtraFieldService.getReportableIssueExtraFieldVals(ticket.id).then(
                                            response1 => {
                                                response1.data.forEach(data => {
                                                    let value = data.value;

                                                    // friendly description of value.
                                                    if (value === 'true') {
                                                        value = 'Si';
                                                    } else if (data.value === 'false') {
                                                        value = 'No';
                                                    }

                                                    ticket[data.extrafield.name] = value;
                                                    if (self.addtHeader.indexOf(data.extrafield.name) === -1) {
                                                        self.addtHeader.push(data.extrafield.name);
                                                        self.addfilterVal.push(data.extrafield.name);
                                                    }
                                                });
                                                if (index === self.list.length - 1) {
                                                    this.listLoading = false;
                                                }
                                            },
                                            error1 => {
                                                console.log(error1.response && error1.response.data ||
                                          error1.message || error1.toString());
                                            }
                                        );

                                    });
                                } else {
                                    this.listLoading = false;
                                }
                            },
                            error => {
                                console.log(error.response && error.response.data ||
                          error.message || error.toString());
                                this.listLoading = false;
                            }
                        );
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            } else {
                this.doFiltering(this.rawList, filteredBy);
            }

        },
        doFiltering(data, filteredBy) {
            // const endStatus = ['RequestedReplace', 'Repaired', 'RepairedSancor', 'NotRepaired'];
            this.list = data;

            if (this.filter.state !== 'ALL') {
                if (this.filter.state === 'repaired') {
                    this.list = this.list.filter(issue => {
                        return issue.status2 && (issue.status2.last || issue.status2.name === 'Garantía no aprobada');
                    });
                } else if (this.filter.state === 'open') {
                    this.list = this.list.filter(issue => {
                        return !issue.status2 || !issue.status2.last && issue.status2.name !== 'Reparado Sancor';
                    });
                } else if (this.filter.state === 'ended') {
                    this.list = this.list.filter(issue => {
                        return issue.status2 && (issue.status2.last || issue.status2.name === 'Reparado Sancor');
                    });
                } else if (this.filter.state === 'closed') {
                    this.list = this.list.filter(issue => {
                        return !issue.active;
                    });
                }
            }

            if (this.filter.technician !== 'ALL') {
                this.list = this.list.filter(issue => {
                    return !issue.assignedTo || issue.assignedTo.username === this.filter.technician;
                });
            }

            if (filteredBy) {
                if (filteredBy === 'Smartdrone') {
                    this.list = this.list.filter(issue => {
                        return !issue.issueType || issue.issueType === '';
                    });
                } else if (filteredBy === 'Presupuesto') {
                    this.list = this.list.filter(issue => {
                        return issue.issueType && (
                            issue.issueType.toUpperCase() === filteredBy.toUpperCase() ||
                            issue.issueType.toUpperCase() === 'P'
                        );
                    });
                } else if (filteredBy.length) {
                    this.list = this.list.filter(issue => {
                        return issue.issueType && issue.issueType.toUpperCase() === filteredBy.toUpperCase();
                    });
                }
            }
        },
        doFilter() {
            this.onChange(true);
        },
        removeFilter() {
            this.filter = {
                state: 'ALL',
                type: 'ALL',
                customer: 'ALL'
            };
            this.fetchData(false);
        },
        onChange(fromDate) {
            if (this.filter.type === 'ALL') {
                this.fetchData(null, fromDate === true);
            } else {
                this.fetchData(this.filter.type, fromDate === true);
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleDownload() {
            this.downloadLoading = true;
            import('@/utils/export-excel').then(excel => {
                let tHeader = [
                    'Id',
                    'Fecha Ingreso',
                    'Nombre Cliente',
                    'Teléfono',
                    'Número de Factura',
                    'Fecha',
                    'SKU',
                    'Dispositivo',
                    'IMEI/Serial',
                    'Problema',
                    'Diagnóstico',
                    'Estado',
                    'Técnico',
                    'Costo',
                    'Precio',
                    'Activo'
                ];
                let filterVal = [
                    'id',
                    'dateCreated',
                    'customerFullName',
                    'customerPhone',
                    'documentReferredId',
                    'documentReferredDate',
                    'sku',
                    'deviceBrand',
                    'serialNo',
                    'issueDescription',
                    'issueDiagnostic',
                    'status',
                    'assignedTo',
                    'Costo',
                    'Precio',
                    'active'
                ];

                if (this.addtHeader) {
                    tHeader = tHeader.concat(this.addtHeader);
                    filterVal = filterVal.concat(this.addfilterVal);
                }
                const list = this.multipleSelection.length ? this.multipleSelection : this.list;
                const data = this.formatJson(filterVal, list);

                //  ExtraFieldService.getReportableIssueExtraFieldVals
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: this.filename,
                    autoWidth: this.autoWidth,
                    bookType: this.bookType
                });
                /* if (this.multipleSelection.length) {
                    this.$refs.multipleTable.clearSelection();
                }*/
                this.downloadLoading = false;
            });
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                if (j === 'timestamp') {
                    return parseTime(v[j]);
                } else if (j === 'id') {
                    return this.getTicketId(v);
                } else if (j === 'dateCreated') {
                    return this.formatDate(v[j]);
                } else if (j === 'assignedTo') {
                    return v[j] && v[j].username;
                } else if (j === 'status') {
                    // return this.translateStatus(v[j]);
                    if (v['status2']) {
                        return v['status2'].name;
                    }
                    return 'Nuevo';
                } else if (j === 'active') {
                    return this.getActive(v[j]);
                } else if (j === 'customerFullName') {
                    return v['customer'].firstName;
                } else if (j === 'customerPhone') {
                    return v['customer'].phone;
                }

                return v[j];

            }));
        }
    }
};
</script>

<style lang="scss">
.radio-label {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  //padding: 0 12px 0 30px;
  padding-right: 10px;
  letter-spacing:-1px;
}
.el-radio.is-bordered {
    margin: 0;
}
.filter-actions {
    button {
        width: 125px;
        margin-bottom: 5px;
    }
}
.el-table .cell {
    word-break: break-word;
}
.el-loading-spinner {
    top: 100px;
}
</style>
